var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 120 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16345 7.16344 0 16 0H104C112.837 0 120 7.16344 120 16V100C120 133.137 93.1371 160 60 160C26.8629 160 0 133.137 0 100V16Z",
    fill: "#B5B5C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19C4 11.268 10.268 5 18 5H102C109.732 5 116 11.268 116 19V100C116 130.928 90.928 156 60 156C29.0721 156 4 130.928 4 100V19Z",
    fill: "url(#paint0_linear_12_2115)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22C9 15.3726 14.3726 10 21 10H99C105.627 10 111 15.3726 111 22V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V22Z",
    fill: "url(#paint1_linear_12_2115)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2843 52L60.2843 80.2843L88.5685 80.2843L60.2843 52Z",
    fill: "#B9B8B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5733 80.2842L60.2891 80.2842L60.2891 108.568L88.5733 80.2842Z",
    fill: "#9F9F9F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.003 80.2842L60.2873 80.2842L60.2873 108.568L32.003 80.2842Z",
    fill: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2843 52L60.2843 80.2843L32 80.2843L60.2843 52Z",
    fill: "#F3F3F3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_2115",
    x1: 6.24,
    y1: 8.99815,
    x2: 35.479,
    y2: 114.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#A6A5B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898838,
    stopColor: "#D9D9DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_2115",
    x1: 60,
    y1: 10,
    x2: 60,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B3843"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverIcon);
export default __webpack_public_path__ + "static/media/silverIcon.d9fce70aa3e911fb9b3117a5c8a29821.svg";
export { ForwardRef as ReactComponent };